import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchBrands } from '../lib/api';
import { Loader2 } from 'lucide-react';

const BrandsPage = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBrands().then(setBrands).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <h1 className="text-4xl md:text-5xl font-black tracking-tight">Our Brands</h1>
        <p className="text-neutral-600 mt-3">We carry only the most trusted names in performance nutrition.</p>
      </div>
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-neutral-400" /></div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {brands.map(b => (
            <Link key={b.id} to={`/shop?brand=${b.id}`} className="bg-white border border-neutral-200 rounded-lg p-6 flex flex-col items-center justify-center gap-3 hover:shadow-xl hover:border-[#0a0a0a] hover:-translate-y-1 transition-all aspect-square">
              <img src={b.logo} alt={b.name} className="max-w-full max-h-24 object-contain" />
              <span className="text-sm font-bold uppercase tracking-wider text-center">{b.name}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BrandsPage;
